// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantProfileTabs-moduleskeleton__vAjqo Skeleton-moduleSkeleton__Mlrfv";
var _2 = "RentalPortalApplicantProfileTabs-moduletabsWrapper__G5Ucp TabScrollList-modulewrapper__zIrvw";
export { _1 as "skeleton", _2 as "tabsWrapper" }
